(function () {
  function init(el) {
    const textEl = el.querySelector('[data-low-stock-text]');
    const variantsScript = el.querySelector('[data-variants-json]');
    if (!textEl || !variantsScript) return;

    let variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    // Find the closest product form and variant id input
    const root = el.closest('section') || document;
    const form = root.querySelector('form[action*="/cart/add"]');
    const idInput = form ? form.querySelector('input[name="id"]') : null;
    if (!idInput) return;

    function messageFor(variant) {
      if (!variant) return '';
      // Only show when Shopify tracks inventory AND overselling is denied
      if (!variant.available) return '';
      if (variant.inventory_management !== 'shopify') return '';
      if (variant.inventory_policy !== 'deny') return '';

      const qty = Number(variant.inventory_quantity);
      if (qty === 1) return 'Only 1 left in stock';
      if (qty === 2) return 'Only 2 left in stock';
      return '';
    }

    function update() {
      const id = Number(idInput.value);
      const v = variants.find(x => Number(x.id) === id);
      textEl.textContent = messageFor(v);
    }

    // Update on any option change inside the product area
    root.addEventListener('change', function (e) {
      if (e.target && e.target.closest('form[action*="/cart/add"]')) update();
    });

    update();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-low-stock]').forEach(init);
  });
})();
